import React from 'react';

function UserAvatar(props) {
  return (
    <svg fill="none" viewBox="0 0 26 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M15.8076 11.304C17.7066 10.2967 19 8.29938 19 6C19 2.68629 16.3137 0 13 0C9.68629 0 7 2.68629 7 6C7 8.29938 8.29344 10.2967 10.1924 11.304C4.36233 12.5874 0 17.7843 0 24C0 31.1797 5.8203 37 13 37C20.1797 37 26 31.1797 26 24C26 17.7843 21.6377 12.5874 15.8076 11.304Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default UserAvatar;
